import {
  DefaultsDocument,
  UserProfileAddValpayCcDocument,
  UserProfileAddValpayCcMutationVariables,
  UserProfileDocument,
  ValpayConfigDocument,
} from "@graphql/api";

export default async function userProfileAddValpayCc(
  encryptedCardNumber: string,
  encryptedExpiryMonth: string,
  encryptedExpiryYear: string,
  encryptedSecurityCode: string,
  ccCardHolderName?: string,
  ccPostalCode?: string,
  shopperReference?: string
): Promise<boolean> {
  const client = global.window.apolloClient;

  const mutVars: UserProfileAddValpayCcMutationVariables = {
    encryptedCardNumber,
    encryptedExpiryMonth,
    encryptedExpiryYear,
    encryptedSecurityCode,
    ccCardHolderName,
    ccPostalCode,
  };

  const result = await client.mutate({
    mutation: UserProfileAddValpayCcDocument,
    variables: mutVars,
    // Refetch only the queries that display credit card data
    // IMPORTANT: ValpayConfigDocument needs the same variables that the Valpay component uses
    refetchQueries: [
      { query: UserProfileDocument },
      { query: DefaultsDocument },
      // Include shopperReference in refetch so Apollo updates the correct cache entry
      { query: ValpayConfigDocument, variables: { shopperReference } },
    ],
    awaitRefetchQueries: true,
  });

  return result.data?.userProfileAddValpayCc?.success ?? false;
}
